import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { Apply } from "./routes/apply/Apply";
import { InterviewScheduling } from "./routes/interview/InterviewScheduling";
import { SignIn } from "./routes/login/SignIn";
import { Onboarding } from "./routes/onboarding/Onboarding";

// guide-web ルーティング（純SPA / tst-sg7.6）。
// 公開: /apply（G-01 応募）・/interview（R-12 第3ステップ 面接日程選択・token 照合）・/login（G-03 サインイン）。
// 認証必須: /onboarding（G-02）。guide.status を読んで居場所を振り分ける状態別ランディングで、
// 未提出のときだけオンボーディング Wizard を出す（tst-00cu.5 / routes/onboarding/landing.ts）。
// 既定 / は /apply（新規応募者の入口）へ。
export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/apply" replace />} />
          <Route path="/apply" element={<Apply />} />
          {/* 応募者は Accepted まで Cognito アカウントを持たないため未認証（tst-bak0.1.32）。 */}
          <Route path="/interview" element={<InterviewScheduling />} />
          <Route path="/login" element={<SignIn />} />
          <Route
            path="/onboarding"
            element={
              <RequireAuth>
                <Onboarding />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/apply" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
